<template>
  <v-layout align-center justify-center>
    <v-flex xs8>
      <v-select
        v-model="facility"
        @change="$emit('facility-changed', parseInt($event, 10))"
        outlined
        dense
        hide-details
        clearable
        :rules="requiredRule"
        label="Select facility"
        :items="this.getFacilities"
        item-value="node.facilityId"
        item-text="node.name"
      >
        <template v-slot:item="{ item, on, attrs }">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title
                v-text="item.node.name"
                v-on="on"
                v-bind="attrs"
              ></v-list-item-title>
              <v-list-item-subtitle
                v-on="on"
                v-bind="attrs"
                v-text="item.node.desc"
              ></v-list-item-subtitle>
            </v-list-item-content>
            <v-list-item-action
              v-if="
                // eslint-disable-next-line prettier/prettier
                hasUser &&
                user.role === 'Administrator' ||
                  +item.node.userId === +user.userId
              "
            >
              <v-btn icon>
                <v-icon
                  color="grey lighten-1"
                  @click="deleteFacility(item.node.facilityId)"
                  >fa-trash-alt</v-icon
                >
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-select>
    </v-flex>
    <v-flex xs2 v-if="hasUser">
      <v-dialog
        v-model="dialog"
        :retain-focus="false"
        max-width="700px"
        persistent
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            outlined
            color="light-blue darken-4"
            dark
            v-bind:attrs="attrs"
            v-on="on"
          >
            Add facility
          </v-btn>
        </template>
        <facilityForm @close-form="closeForm" />
      </v-dialog>
    </v-flex>
  </v-layout>
</template>
<script>
import { validation } from "../../mixins/validationMixin";
import { mapMethods } from "../../mixins/map";
import facilityForm from "@/components/forms/facilityForm";
import { mapGetters } from "vuex";

export default {
  props: {
    currentFacility: {
      type: [String, Number, Boolean]
    }
  },
  components: { facilityForm },
  mixins: [validation, mapMethods],
  mounted() {
    if (this.currentFacility) {
      this.facility = String(this.currentFacility);
    }
    this.$store.dispatch("allFacility");
  },
  beforeDestroy() {
    this.facility = "";
  },
  data() {
    return {
      facility: "",
      dialog: false
    };
  },
  watch: {
    currentFacility(val) {
      if (val) {
        this.facility = String(val);
      } else {
        this.facility = "";
      }
    }
  },
  computed: {
    ...mapGetters(["hasUser", "user", "meets", "getFacilities"])
  },
  methods: {
    closeForm() {
      this.dialog = false;
    },
    deleteItem(id) {
      this.deleteFacility(id);
    }
  }
};
</script>
